<template>
  <Collapsible
    v-model="localValue"
    @opened="$emit('opened')"
    @closed="$emit('closed')"
    :class="[commonCollapseClass, additionalCollapseClass]"
  >
    <template #trigger="{ isOpen, toggle }">
      <div
        class="w-full flex flex-row items-center justify-between gap-2 cursor-pointer"
        @click="toggle"
      >
        <h3
          class="text-[1rem] md:text-[1.375rem] lg:text-[1.625rem] leading-[1.375rem] md:leading-[1.875rem] lg:leading-[2.125rem] font-bold font-[#373E49]"
          v-html="title"
        />
        <img
          src="/assets/icons/chevron-down.svg"
          alt=""
          class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] lg:w-[28px] lg:h-[28px]"
          :class="[
            'theme-accordian-icon',
            'transition-transform duration-300 ease-in-out',
            isOpen ? 'rotate-0' : 'rotate-[-90deg]',
          ]"
        />
      </div>
    </template>
    <template #collapsible="{ isOpen }">
      <div
        v-show="isOpen"
        class="w-full text-[0.875rem] md:text-[1.125rem] lg:text-[1.375rem] leading-[1.25rem] md:leading-[1.625rem] lg:leading-[1.875rem] font-medium pt-[8px]"
        v-html="description"
      />
      <!-- Hardcoded in -->
      <div v-show="isOpen && isGeneralFund">
        <br />
        <a
          class="text-[0.875rem] md:text-[1.125rem] lg:text-[1.375rem] leading-[1.25rem] md:leading-[1.625rem] lg:leading-[1.875rem] font-medium text-[#454BEF] underline"
          @click="gotoTitheMsg()"
        >
          Why is tithing important?
        </a>
      </div>
    </template>
  </Collapsible>
</template>

<script>
import Collapsible from '@/components/design/Collapsible';
import HasLocalValue from '@/mixins/HasLocalValue';

export default {
  components: {
    Collapsible,
  },

  mixins: [HasLocalValue],

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    additionalCollapseClass: {
      type: String,
      default: '',
    },
    initialOpen: {
      type: Boolean,
      default: true,
    },
    isGeneralFund: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: false,
      commonCollapseClass: 'bg-[#ffffff] rounded-2xl p-[16px]',
    };
  },
  methods: {
    gotoTitheMsg() {
      this.$router.push('/my-giving/tithing-message');
    },
  },
};
</script>
